import { render } from "./menu-domain.vue?vue&type=template&id=bc6456c0&scoped=true"
import script from "./menu-domain.vue?vue&type=script&lang=js"
export * from "./menu-domain.vue?vue&type=script&lang=js"

import "./menu-domain.vue?vue&type=style&index=0&id=bc6456c0&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc6456c0"]])

export default __exports__